import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectFilterModule } from 'mat-select-filter';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MtsDateFormate } from 'src/app/constant/mtsdateformate';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { DivisionService } from 'src/app/services/division.service';
import { RegionService } from 'src/app/services/region.service';
import { ReportsService } from 'src/app/services/reports.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { TripEntryService } from 'src/app/services/tripentry.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { DirectivesModule } from 'src/app/views/layout/directives/directives.module';
import { WaitingListReportComponent } from './waiting-list-report.component';

const routes: Routes = [
  {
      path: '',
      component: WaitingListReportComponent
  },
]

@NgModule({
  declarations: [WaitingListReportComponent],
  providers: [
    ReportsService,
    VehicleService,
    RegionService,
    DivisionService,
    SubDivisionService,
    TripEntryService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MtsDateFormate }, 
    
],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    FeahterIconModule,
    NgbDropdownModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    DirectivesModule,
    NgMultiSelectDropDownModule.forRoot(),
    PdfViewerModule,
    MatSelectModule, 
    MatSelectFilterModule
  ]
})
export class WaitingListReportModule { }
